import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, useUitkContext } from 'uitk-react-utils';
import styles from './uitk-text.css';
import { UitkSubHeadingTags, UitkTypeAlignments, UitkTypeOverflows, UitkTypeHyphens } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
/**
 * Use only for subheadings, which immediately follow a heading.
 * Should not be used standalone or inline with other content.
 */
var UitkSubheading = function (props) {
    var align = props.align, className = props.className, children = props.children, tag = props.tag, overflow = props.overflow, hyphens = props.hyphens, attributes = __rest(props, ["align", "className", "children", "tag", "overflow", "hyphens"]);
    var defaultTag = 'p';
    var Tag = (tag && UitkSubHeadingTags.get(tag)) || defaultTag;
    var contextData = useUitkContext().data;
    var _a = contextData !== null && contextData !== void 0 ? contextData : {}, bottomScrimContext = _a.bottomScrimContext, overlayScrimContext = _a.overlayScrimContext, contextClassNames = _a.contextClassNames;
    var wrapperClassNames = getClassNameList('uitk-subheading', align && UitkTypeAlignments.get(align), overflow && UitkTypeOverflows.get(overflow), hyphens && UitkTypeHyphens.get(hyphens), bottomScrimContext && "in-bottom-scrim", overlayScrimContext && "in-overlay-scrim", contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkSubheading, className);
    return children ? (React.createElement(Tag, __assign({ className: wrapperClassNames }, attributes), children)) : null;
};

export { UitkSubheading };
